// Module
var code = "<div class=\"card\"> <div class=\"card-content\"> <p><b>Zenflow Support</b></p> </div> </div> ";
// Exports
export default code;